import type { VaultV1Migration } from '@/lib/procedures/vaultV1Migration.contract'

interface VaultV1Migrations {
  items: readonly VaultV1Migration[]
}

export const buildMigrationKey = (chainId: number, v1VaultAddress: string): string =>
  `${chainId}-${v1VaultAddress.toLowerCase()}`

// Shared across consumers: react-query already dedupes the network fetch by
// key, but each row would otherwise build its own Map over the same payload.
// Keying on the response object lets every row reuse the same Map instance.
const indexCache = new WeakMap<VaultV1Migrations, Map<string, VaultV1Migration>>()

export const getMigrationIndex = (data: VaultV1Migrations): Map<string, VaultV1Migration> => {
  const cached = indexCache.get(data)
  if (cached) return cached
  const map = new Map(
    data.items.map(item => [buildMigrationKey(item.chainId, item.v1VaultAddress), item])
  )
  indexCache.set(data, map)
  return map
}
